let LandingPages = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.addForm();
        this.editForm();
        this.duplicateForm();
        this.form();
        this.delete();
    },

    addForm: function () {
        let _this = this;

        const landingPageForm = $('#landingPageForm');

        if (landingPageForm.length) {
            $(document).on('click', '.add-landing-page', () => {
                landingPageForm.find('#landingPageId').val('');
                landingPageForm.find('#landingPageTitle').val('');
                landingPageForm.find('#landingPageSlug').val('');
                landingPageForm.find('#landingPageContent').val('');
                landingPageForm.find('#landingPageVideo').val('');

                landingPageForm.resetForm();
                $('#landingPageStatus').change();
                landingPageForm.find('#landingPageCategories').change();
                landingPageForm.find('#landingPageImagePreview').hide();
            });
            let submitBtn = Ladda.create(landingPageForm.find('[type=submit]')[0]);

            landingPageForm.ajaxForm({
                beforeSubmit: function () {
                    $('.form-group').removeClass('has-error');
                    submitBtn.start();
                },
                success: function (response) {
                    if (response.success) {
                        window.location.reload();
                    } else {
                        submitBtn.stop();
                        toastr.error(response.message);
                    }
                },
                error: function (err) {
                    submitBtn.stop();

                    let error = err.responseJSON;

                    if (error.errors) {
                        toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                        Object.keys(error.errors).forEach(field => {
                            $('[name=' + field + ']').closest('.form-group').addClass('has-error');
                        });
                    } else {
                        toastr.error(error.message);
                    }

                }
            });
        }
    },

    editForm: function () {
        let _this = this;

        const landingPageForm = $('#landingPageForm');
        const landingPageModal = $('#landingPageModal');

        $('.edit-landing-page').click(function () {
            const id = $(this).data('id');
            const row = $(this).closest('tr');

            $.get('/pages/landing/' + id + '/json', response => {
                if (response.success) {
                    const page = response.data;

                    landingPageForm.find('#landingPageTitle').val(page.title);
                    landingPageForm.find('#landingPageSlug').val(page.slug);
                    tinymce.get('landingPageContent').setContent(page.content)
                    landingPageForm.find('#landingPageStatus').val(page.status);
                    landingPageForm.find('#landingPagePostedAt').val(page.posted_at_formatted);
                    landingPageForm.find('#landingPageId').val(page.id);
                    landingPageForm.find('#landingPageVideo').val(page.video);
                    landingPageForm.find('#landingPageCategories').val(page.categories);
                    landingPageForm.find('#landingPageCategories').change();

                    if (page.image) {
                        landingPageForm.find('#landingPageImagePreview').attr('src', page.image).show();
                    } else {
                        landingPageForm.find('#landingPageImagePreview').hide();
                    }

                    landingPageModal.modal('show');
                }
            });
        });
    },

    duplicateForm: function () {
        let _this = this;

        const landingPageDuplicateForm = $('#landingPageDuplicateForm');

        $('.duplicate-landing-page').click(function () {
            const id = $(this).data('id');

            landingPageDuplicateForm.find('#landingPageDuplicateId').val(id);
        });

        let submitBtn = Ladda.create(landingPageDuplicateForm.find('[type=submit]')[0]);

        landingPageDuplicateForm.ajaxForm({
            beforeSubmit: function () {
                $('.form-group').removeClass('has-error');
                submitBtn.start();
            },
            success: function (response) {
                if (response.success) {
                    window.location.reload();
                } else {
                    submitBtn.stop();
                    toastr.error(response.message);
                }
            },
            error: function (err) {
                submitBtn.stop();

                let error = err.responseJSON;

                if (error.errors) {
                    toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                    Object.keys(error.errors).forEach(field => {
                        $('[name=' + field + ']').closest('.form-group').addClass('has-error');
                    });
                } else {
                    toastr.error(error.message);
                }

            }
        });
    },

    delete: function () {
        $('.delete-landing-page').click(function () {
            let id = $(this).data('id');
            let row = $(this).closest('tr');

            swal({
                title: "Are you sure?",
                text: "Your will not be able to recover this page!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: "Yes, delete it!"
            }).then((result) => {
                if (result.value) {
                    $.post('/pages/landing/' + id,
                        {
                            _method: 'delete'
                        },
                        (result) => {
                            if (result.success) {
                                let table = row.closest('table').DataTable();
                                table.row(row).remove().draw();
                                swal(
                                    'Deleted!',
                                    'Landing Page has been deleted.',
                                    'success'
                                ).then((result) => {

                                });
                            }
                        });
                }
            });
        });
    },

    form: function () {
        let _this = this;
        const landingPageForm = $('#landingPageForm');

        $(document).on('blur', '#landingPageTitle', function (e) {
            const title = $(this).val();
            const slug = $('#landingPageSlug');

            if (slug.val() === '') {
                slug.val(slugify(title));
            }
        });

        $(document).on('blur', '#landingPageDuplicateTitle', function (e) {
            const title = $(this).val();
            const slug = $('#landingPageDuplicateSlug');

            if (slug.val() === '') {
                slug.val(slugify(title));
            }
        });

        $('#landingPages').on('draw.dt', function () {
            _this.editForm();
            _this.delete();
        });
    },
};

$().ready(function () {
    window.LandingPages = LandingPages;
    window.LandingPages.init();
});
